import React, {useEffect, useState} from "react";
import {Badge, Box, Center, Spinner, Table, Tbody, Td, Th, Thead, Tr, useToast} from "@chakra-ui/react";
import {getCompanies} from "../../api/getCompanies";
import {format} from "date-fns";
import {getLastSPVCrawls} from "../../../MainPage/api/getLastSPVCrawl";
import {getDocumentStats} from "../../api/getDocumentStats";

const CompanyTable = () => {
    const [companies, setCompanies] = useState([]);
    const [lastSPVCrawls, setLastSPVCrawls] = useState([]);
    const [documentStats, setDocumentStats] = useState([]);
    const [loading, setLoading] = useState(true);
    const toast = useToast();

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        try {
            const [companiesRes, crawlsRes, docsRes] = await Promise.all([
                getCompanies(),
                getLastSPVCrawls(),
                getDocumentStats()
            ]);

            setCompanies(companiesRes || []);
            setLastSPVCrawls(crawlsRes || []);
            setDocumentStats(docsRes || []);
        } catch (error) {
            toast({
                title: "Error",
                description: "Failed to load data.",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        } finally {
            setLoading(false);
        }
    };

    const getTokenExpiration = (token) => {
        try {
            const [, payload] = token.split(".");
            const decoded = JSON.parse(atob(payload));
            return decoded.exp ? new Date(decoded.exp * 1000) : null;
        } catch (error) {
            console.error("Invalid token", error);
            return null;
        }
    };

    return (
        <Box overflowX="auto" minHeight="250px">
            {loading ? (
                <Center height="300px" bg="gray.100">
                    <Spinner size="xl"/>
                </Center>
            ) : (
                <Table variant="striped" size="sm">
                    <Thead>
                        <Tr>
                            <Th>#</Th>
                            <Th>CIF</Th>
                            <Th>Denumire</Th>
                            <Th>Total documente neprocesate</Th>
                            <Th>Total documente aprobate</Th>
                            <Th>Total documente trimise la OMC</Th>
                            <Th>Total documente arhivate</Th>
                            <Th>Ultima actualizare SPV</Th>
                            <Th>Ultima indexare</Th>
                            <Th>Dată expirare token</Th>
                            <Th>Status token</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {companies.length > 0 ? (
                            companies.map((company) => {
                                const lastSPVCrawl = lastSPVCrawls.find(entry => entry.cif === company.cif);
                                const companyDocumentStats = documentStats.find(entry => entry.cif === company.cif);
                                const expirationDate = getTokenExpiration(company.token);
                                const isValid = expirationDate && expirationDate >= new Date();

                                return (
                                    <Tr key={company.id}>
                                        <Td>{company.id}</Td>
                                        <Td>{company.cif}</Td>
                                        <Td>{company.name}</Td>
                                        <Td>{companyDocumentStats?.totalPendingDocuments || 0}</Td>
                                        <Td>{companyDocumentStats?.totalApprovedDocuments || 0}</Td>
                                        <Td>{companyDocumentStats?.totalSentToOmcDocuments || 0}</Td>
                                        <Td>{companyDocumentStats?.totalArchivedDocuments || 0}</Td>
                                        <Td>{lastSPVCrawl ? format(lastSPVCrawl.endTimestamp, 'yyyy-MM-dd HH:mm') : "N/A"}</Td>
                                        <Td>{lastSPVCrawl?.totalEntries || "N/A"}</Td>
                                        <Td>{expirationDate ? format(expirationDate, 'yyyy-MM-dd HH:mm') : "N/A"}</Td>
                                        <Td>
                                            <Badge colorScheme={isValid ? "green" : "red"}>
                                                {isValid ? "Valid" : "Expirat"}
                                            </Badge>
                                        </Td>
                                    </Tr>
                                );
                            })
                        ) : (
                            <Tr>
                                <Td colSpan={11} textAlign="center">Nu există date</Td>
                            </Tr>
                        )}
                    </Tbody>
                </Table>
            )}
        </Box>
    );
};

export default CompanyTable;
